import $ from "jquery";
import * as FilePond from "filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageCrop from "filepond-plugin-image-crop";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import FilePondPluginImageTransform from "filepond-plugin-image-transform";
import FilePondPluginImageEdit from "filepond-plugin-image-edit";

import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css";

import "jquery-validation";

FilePond.registerPlugin(FilePondPluginFileValidateType);
FilePond.registerPlugin(FilePondPluginImageExifOrientation);
FilePond.registerPlugin(FilePondPluginImagePreview);
FilePond.registerPlugin(FilePondPluginImageCrop);
FilePond.registerPlugin(FilePondPluginImageResize);
FilePond.registerPlugin(FilePondPluginImageTransform);
FilePond.registerPlugin(FilePondPluginImageEdit);

export const jobFiles = FilePond.create(document.querySelector("#job_files"), {
  name: "job_files[]",
  credits: false,
  allowMultiple: true,
  acceptedFileTypes: ["image/*"],
  maxFiles: 10,
  maxFileSize: "10MB",
  imagePreviewHeight: 170, // Установите высоту предпросмотра
  imageCropAspectRatio: 1, // Установите соотношение сторон для обрезки
  allowImagePreview: true, // Разрешите предпросмотр изображений
  labelIdle:
    'Перетащите ваши файлы в поле или <span class="filepond--label-action"> выберите файлы вручную </span>',
  labelMaxFileSizeExceeded: "Файл больше 5МБ",
  labelMaxFileSize: "Максимальный размер файла это: {filesize}",
  itemInsertLocation: "after",
});

// Функция инициализации валидации форм
function initJobFormValidation(formSelector) {
  $(formSelector).validate({
    ignore: 'input[type="file"]', // игнорируем файлы

    rules: {
      job_name: {
        required: true,
        maxlength: 55,
      },
      job_description: {
        required: true,
        maxlength: 1500,
      },
      job_category: {
        required: true,
      },
      job_price: {
        required: true,
        number: true,
        min: 1,
      },
    },

    messages: {
      job_name: {
        required: "Введите название работы",
        maxlength: "Название не должно превышать 55 символов",
      },
      job_description: {
        required: "Введите описание работы",
        maxlength: "Описание не должно превышать 1500 символов",
      },
      job_category: {
        required: "Выберите категорию",
      },
      job_price: {
        required: "Укажите цену",
        number: "Введите корректное число",
        min: "Цена должна быть больше 0",
      },
    },

    errorElement: "span",
    errorClass: "validation-error",

    errorPlacement: function (error, element) {
      if (
        element.closest(
          ".reusable, .measurements__dropdown, .price__input-wrapper, .dropdown"
        ).length
      ) {
        error.appendTo(
          element.closest(
            ".reusable, .measurements__dropdown, .price__input-wrapper, .dropdown"
          )
        );
      } else {
        error.insertBefore(element);
      }
    },

    highlight: function (element) {
      if ($(element).closest(".dropdown").length) {
        $(element).closest(".dropdown").addClass("is-invalid");
      } else {
        $(element).addClass("is-invalid");
      }
    },

    unhighlight: function (element) {
      if ($(element).closest(".dropdown").length) {
        $(element).closest(".dropdown").removeClass("is-invalid");
      } else {
        $(element).removeClass("is-invalid");
      }
    },
  });
}

// Инициализация валидации для обеих форм
initJobFormValidation("#addJobForm");
initJobFormValidation("#editJobForm");


